export { default as ShipmentInfoReturnListTemplate } from './ShipmentInfoReturnListTemplate';
export { default as ShipmentInfoReturnDetailListTemplate } from './ShipmentInfoReturnDetailListTemplate';



// WEBPACK FOOTER //
// ./src/themes/default/modules/shipment-info-return/pages/index.js